import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const normalize = (options) => ({
  pageParam: 'page',
  filtersCollapsable: true,
  ...options,
});

export default (options) => {
  const config = normalize(options);

  return {
    namespaced: true,
    state: () => ({
      pageTitle: '',
      pageMetaData: {},
      breadcrumbsArr: [],
      searchObj: {},
      searchResults: [],
      facets: [],
      appliedRefinements: [],
      filterModalOpened: false,
      toggledFilterMenus: [],
    }),
    mutations,
    actions: actions(config),
    getters: getters(config),
  };
};
